<template>
  <div class="line-item">
    <div class="line-item__header">
      <div>
        Line # {{ lineItem.Number }}:
        {{ lineItem.RequestedProductNameSlashNum }}        
      </div>
      <div class="pull-right">    
        <a
          v-if="lineItem.HasAttachments"
          class="line-item__attachment-button"
          @click="downloadAttachment"
        >
          <font-awesome-icon icon="fa-solid fa-download" /> Attachments
        </a>    
        <span v-if="lineItem.HasLabel" class="yellow"
          >[{{ EnumMerchStatus[lineItem.Status] }}]</span
        >       
      </div>
    </div>
    <div v-if="originalView" class="line-item__original-view">
      <div class="line-item__view-container">
        <div class="line-item__view-column">
          <div>
            <span class="cc-label-name"
              >Label Name/#: {{ lineItem.RequestedLabelNameNum }}</span
            >
          </div>
          <div>
            <span class="cc-label-name"
              >Brand: {{ lineItem.RequestedBrand }}</span
            >
          </div>
          <div v-if="lineItem.RequestedCategory">
            <span class="cc-label-name">Category: </span
            ><strong>{{ lineItem.RequestedCategory }}</strong>
          </div>
          <div>
            <span class="cc-label-name yellow"
              >Plant: {{ lineItem.PlantName }} [{{
                lineItem.PlantProductionType
              }}]
            </span>
          </div>
          <div v-if="lineItem.RequestedPesach">
            <span class="cc-label-name">Pesach: </span>
            <span>*** Requested {{ lineItem.LineInstructions }}</span>
          </div>
          <div
            v-if="
              lineItem.RequestedConfidential == EnumConfidential.Confidential ||
              lineItem.RequestedConfidential ==
                EnumConfidential.UkdOnlyButNotPublicUkd
            "
          >
            <span class="cc-label-name">{{
              EnumConfidential[lineItem.RequestedConfidential]
            }}</span>
          </div>
        </div>
        <div class="line-item__view-column right">
          <div>
            <span class="cc-label-name">{{
              EnumDpm[lineItem.RequestedDpm!]
            }}</span>
          </div>

          <div>
            <span class="cc-label-name">{{
              EnumLabelType[lineItem.RequestedLabelType!]
            }}</span>
          </div>

          <div>
            <span class="cc-label-name">{{
              lineItem.RequestedConsumerIndustrialFullWord
            }}</span>
          </div>

          <div>
            <span
              v-if="lineItem.RequestedShippingFullWord"
              class="cc-label-name"
              >{{ lineItem.RequestedShippingFullWord }}</span
            >
          </div>

          <div>
            <span
              v-if="lineItem.RequestedForInternalUseOnly"
              class="cc-label-name"
              >Internal Use</span
            >
          </div>

          <div>
            <span class="cc-label-name">Line Item Status: </span>
            <span>{{ EnumMerchStatus[lineItem.Status] }}</span>
          </div>

          <div v-if="lineItem.RequestedPesach">
            <span class="cc-label-name">Pesach: </span>
            <span>*** Requested</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="line-item__view">
      <div class="line-item__view-container">
        <div v-if="lineItem.HasLabel" class="line-item__view-column">
          <div>
            <span class="cc-label-name">{{ lineItem.LabelNameNum }}</span>
          </div>
          <div>
            <span class="cc-label-name">{{ lineItem.Brand }}</span>
          </div>
          <div v-if="lineItem.RequestedCategory">
            <span class="cc-label-name">Category: </span
            ><strong>{{ lineItem.RequestedCategory }}</strong>
          </div>
          <div>
            <span class="cc-label-name yellow"
              >{{ lineItem.Plant }} [{{ lineItem.PlantProductionType }}]</span
            >
          </div>
        </div>
        <div class="line-item__view-column right">
          <div>
            <span class="cc-label-name">{{ lineItem.Dpm }}</span>
          </div>

          <div>
            <span class="cc-label-name">{{ lineItem.LabelType }}</span>
          </div>

          <div>
            <span class="cc-label-name">{{ lineItem.ConsumerIndustrial }}</span>
          </div>

          <div>
            <span class="cc-label-name">{{ lineItem.Group }}</span>
          </div>

          <div>
            <span class="cc-label-name">{{ lineItem.IntermediateMix }}</span>
          </div>

          <div v-if="lineItem.RequestedPesach">
            <span class="cc-label-name">Pesach: </span>
            <span>*** Requested</span>
          </div>

          <div
            v-if="
              lineItem.RequestedConfidential == EnumConfidential.Confidential ||
              lineItem.RequestedConfidential ==
                EnumConfidential.UkdOnlyButNotPublicUkd
            "
          >
            <span class="cc-label-name">{{
              EnumConfidential[lineItem.RequestedConfidential]
            }}</span>
          </div>
        </div>
      </div>
      <div>
        <span v-if="lineItem.CoPackProductPL" class="cc-label-name yellow"
          >***This formula is exclusive to the distributor. Is this a Co-pack
          candidate?</span
        >
      </div>
      <div v-if="lineItem.LineInstructions && lineItem.LineInstructions.trim()">
        <span class="cc-label-name"
          >Customer Comment: {{ lineItem.LineInstructions.trim() }}</span
        >
      </div>
      <div
        v-if="
          lineItem.ProductValidationComments &&
          lineItem.ProductValidationComments.replace('/', '').trim()
        "
      >
        <span class="cc-label-name">
          {{ lineItem.ProductValidationComments }}
        </span>
      </div>
    </div>

    <div class="line-item__view-footer">
      <div
        v-if="lineItem.Comment.indexOf(IncompatiblePlantTypeAndProductDPM) > 0"
      >
        <span class="cc-label-name-red margin-left-ten urgent-icon">
          {{ lineItem.Comment }}
          <img class="urgent-icon" :src="urgentHeaderIcon" />
          <!-- data-cy="urgent-action"  class="urgent-icon"-->
        </span>
      </div>
      <div v-else>
        <span class="cc-label-name margin-left-ten">
          {{ lineItem.Comment }}
        </span>
      </div>

      <div>
        <span
          v-if="lineItem.DistributorName"
          class="cc-label-name margin-left-ten"
          >New PL Brand Info:<br />{{ lineItem.DistributorName }}<br />
        </span>
        <div>
          <span
            v-if="lineItem.DistributorAddress"
            class="cc-label-name margin-left-ten"
          >
            {{ lineItem.DistributorAddress }}<br />
          </span>
        </div>
        <div>
          <span
            v-if="lineItem.DistributorContactName"
            class="cc-label-name margin-left-ten"
          >
            {{ lineItem.DistributorContactName }}<br />
          </span>
        </div>
        <div>
          <span
            v-if="lineItem.DistributorContactEmail"
            class="cc-label-name margin-left-ten"
          >
            {{ lineItem.DistributorContactEmail }}<br />
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { ProductSubmissionLineItemDisplay } from "@/Domain/ProductSubmissionLineItemDisplay";
import { EnumMerchStatus } from "@/Domain/EnumMerchStatus";
import { EnumConfidential } from "@/Domain/EnumConfidential";
import { EnumDpm } from "@/Domain/EnumDpm";
import { EnumLabelType } from "@/Domain/EnumLabelType";
import { useMainStore } from "@/stores/useMainStore";
import { api } from "@/api";
import urgentHeaderIcon from "@/assets/img/error-icon-15.png";

const main = useMainStore();
const IncompatiblePlantTypeAndProductDPM = "Incompatible Plant Production Type";

const props = defineProps<{
  lineItem: ProductSubmissionLineItemDisplay;
  originalView: boolean;
}>();

const downloadAttachment = function () {
  return api.getDownload("GetSubmissionDetailsAttachment", {
    jobId: props.lineItem.JobId,
    inCartId: props.lineItem.ProductInCartID?.toString() ?? "",
    submissionType: "Product",
  });
};
</script>

<style scoped lang="scss">
.line-item {
  margin-bottom: 10px;
  border: 1px solid #ddd;
  background: #fff;

  &__header {
    display: flex;
    font-size: 13px;
    font-weight: bold;
    padding: 8px 15px;
    border-bottom: 1px solid #e8e8e8;
    background: #efefef;

    .pull-right {
      margin-left: auto;
    }
  }

  &__attachment-button {
    color: #337ab7;
    font-size: 12px;
    cursor: pointer;
    font-weight: normal;
    margin-top: 2px;
    display: inline-block;
    margin-right: 10px;

    &:hover {
      color: #0a58ca;
    }
  }

  &__view {
    padding: 10px;
  }

  &__view-footer {
    padding: 10px;
    display: block;
    flex-direction: column;
    gap: 12px;
  }

  &__view-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  &__view-column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 50%;

    &.right {
      width: auto;
    }
  }

  &__original-view {
    padding: 10px;
  }

  .yellow {
    color: #ec9e39;
    font-weight: normal;
  }
}

.cc-label-name {
  white-space: pre;
  color: #999;
  font-weight: 700;
  font-size: 12px;
  text-wrap: wrap;
}

.cc-label-name-red {
  white-space: pre;
  color: #b51515;
  font-weight: bold;

  .urgent-icon {
    display: block;
  }
}

.k-grid-header {
  background-color: #dedede;
}
</style>
